import { Component, Inject, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { SnackbarService } from '../../services';
import { map } from 'rxjs/operators';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AwareHttpService } from '@appbolaget/aware-http';
import { AwareAuthService } from '@appbolaget/aware-auth';
import { NgFor } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BaseDialogComponent } from '@helpers/base';
import { FileUploaderService } from '@services/http';

@Component({
    selector: 'gdpr-dialog',
    templateUrl: 'gdpr-dialog.html',
    styleUrls: ['./gdpr-dialog.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: true,
    imports: [MatToolbarModule, MatDialogModule, MatIconModule, MatButtonModule, MatTableModule, NgFor],
})
export class GdprDialogComponent extends BaseDialogComponent implements OnInit {
    columnsToDisplay = ['kategorier'];
    expandedElement: GDPRtable | null;
    kategorier: string;
    description: string;

    IS_LOADING: boolean;
    result: any;
    data = {
        client: [],
    };

    table_data: GDPRtable[];

    private awareAuth = inject(AwareAuthService);
    constructor(
        public dialogRef: MatDialogRef<GdprDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public fb: UntypedFormBuilder,
        public snackbarService: SnackbarService,
        public fileUploaderService: FileUploaderService,
        private api: AwareHttpService,
    ) {
        super(dialogRef);

        this.getData();
    }

    ngOnInit() {}

    private getData() {
        this.api
            .get(`export/client/${this.awareAuth.client.uuid}`)
            .execute()
            .pipe(
                map((result: any) => {
                    this.parseClient(result.data);

                    if (result.data.roles.map((r) => r.unit_id) === result.data.units.map((u) => u.id)) {
                        return result.data.units.map((u) => u.title);
                    }

                    this.table_data = [
                        {
                            kategorier: 'Profil',
                            description: `Allmän information.`,
                            info: `
                                <table>
                                  <tr>
                                    <td><b>Förnamn:</b></td>
                                    <td>${this.parseValue(result.data.client.given_name)}</td>
                                  </tr>
                                  <tr>
                                    <td><b>Efternamn:</b></td>
                                    <td>${this.parseValue(result.data.client.family_name)}</td>
                                  </tr>
                                  <tr>
                                    <td><b>Alias:</b></td>
                                    <td>${this.parseValue(result.data.client.alias)}</td>
                                  </tr>
                                  <tr>
                                    <td><b>Födelsedag:</b></td>
                                    <td>${this.parseValue(result.data.client.date_of_birth)}</td>
                                  </tr>
                                  <tr>
                                    <td><b>Kön:</b></td>
                                    <td>${this.parseValue(result.data.client.gender)}</td>
                                  </tr>
                                  <tr>
                                    <td><b>Status:</b></td>
                                    <td>${this.parseValue(result.data.client.status)}</td>
                                  </tr>
                                  <tr>
                                    <td><b>Skapad:</b></td>
                                    <td>${this.parseValue(result.data.client.created_at)}</td>
                                  </tr>
                                  <tr>
                                    <td><b>Senast inloggad:</b></td>
                                    <td>${this.parseValue(result.data.client.authenticated_at)}</td>
                                  </tr>
                                </table>

                                <hr>

                                <table>
                                ${result.data.client.meta
                                    .map((m) => {
                                        return `
                                          <tr>
                                            <td><b>${m.key}</b></td>
                                            <td>${m.value}</td>
                                          </tr>
                                        `;
                                    })
                                    .join(' ')}
                                </table>
                            `,
                        },
                        {
                            kategorier: 'Roller',
                            description: `Dina roller`,
                            info: result.data.roles
                                .map(
                                    (r) =>
                                        `
                                    <table>
                                        <tr>
                                        <td><b>${r.title}: </b></td>
                                        <td> ${this.getUnitNameByRole(r, result.data.units)}</td>
                                      </tr>
                                    </table>
                                    `,
                                )
                                .join(' '),
                        },
                        // {
                        //     kategorier: 'Listeners',
                        //     description: ``,
                        //     info: result.data.client.id
                        // },
                        {
                            kategorier: 'Enheter',
                            description: `Enheter du är kopplad till`,
                            info: result.data.units.map((u) => ` <p> ${u.title}</p>`).join(' '),
                        },
                        {
                            kategorier: 'Mappar',
                            description: ``,
                            info: result.data.buckets
                                .map(
                                    (u) =>
                                        `
                                    <table>
                                        <tr>
                                        <td><b>Titel: </b></td>
                                        <td>${this.parseValue(u.title)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>ID: </b></td>
                                        <td>${this.parseValue(u.ID)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Alias: </b></td>
                                        <td>${this.parseValue(u.alias)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>UUID: </b></td>
                                        <td>${this.parseValue(u.uuid)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Klient ID: </b></td>
                                        <td>${this.parseValue(u.client_id)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Enhets ID: </b></td>
                                        <td>${this.parseValue(u.unit_id)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Förälder ID: </b></td>
                                        <td>${this.parseValue(u.parent_id)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Skapad: </b></td>
                                        <td>${this.parseValue(u.created_at)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Uppdaterad: </b></td>
                                        <td>${this.parseValue(u.updated_at)}</td>
                                        </tr>
                                    </table>
                                    <hr>
                                    <table>
                                    ${result.data.buckets
                                        .map(
                                            (k) =>
                                                `${k.meta
                                                    .map((m) => {
                                                        return `
                                              <tr>
                                                <td><b>${m.key}</b></td>
                                                <td>${m.value}</td>
                                              </tr>
                                            `;
                                                    })
                                                    .join(' ')}`,
                                        )
                                        .join(' ')}
                                    </table>
                                `,
                                )
                                .join(' '),
                        },
                        {
                            kategorier: 'Poster',
                            description: `Poster du har skapat`,
                            info: result.data.posts
                                .map(
                                    (u) =>
                                        `
                            <table>
                                <tr>
                                <td><b>Alias: </b></td>
                                    <td>${this.parseValue(u.alias)} </td>
                                </tr>
                                <tr>
                                <td><b>Titel: </b></td>
                                    <td>${this.parseValue(u.title)} </td>
                                </tr>
                                <tr>
                                <td><b>Content: </b></td>
                                    <td>${this.parseValue(u.content)} </td>
                                </tr>
                                <tr>
                                <td><b>Utdrag: </b></td>
                                    <td>${this.parseValue(u.excerpt)} </td>
                                </tr>
                                <tr>
                                <td><b>Client ID: </b></td>
                                    <td>${this.parseValue(u.client_id)} </td>
                                </tr>
                                <tr>
                                <td><b>Status: </b></td>
                                    <td>${this.parseValue(u.status)} </td>
                                </tr>
                                <tr>
                                <td><b>Skapad: </b></td>
                                    <td>${this.parseValue(u.created_at)} </td>
                                </tr>
                                <tr>
                                <td><b>Publicerad: </b></td>
                                    <td>${this.parseValue(u.publish_at)} </td>
                                </tr>
                                <tr>
                                <td><b>Uppdaterat: </b></td>
                                    <td>${this.parseValue(u.updated_at)} </td>
                                </tr>
                                <tr>
                                <td><b>Utgånget: </b></td>
                                    <td>${this.parseValue(u.expire_at)} </td>
                                </tr>
                                <tr>
                                <td><b>Latitud: </b></td>
                                    <td>${this.parseValue(u.latitude)} </td>
                                </tr>
                                <tr>
                                <td><b>Longitud: </b></td>
                                    <td>${this.parseValue(u.longitude)} </td>
                                </tr>
                                <tr>
                                <td><b>Meta content: </b></td>
                                    <td>${this.parseValue(u.meta_content)} </td>
                                </tr>
                                <tr>
                                <td><b>Meta titel: </b></td>
                                    <td>${this.parseValue(u.meta_title)} </td>
                                </tr>
                            </table>
                            <hr>
                                 `,
                                )
                                .join(' '),
                        },
                        {
                            kategorier: 'Filer',
                            description: ``,
                            info: `
                            <table>
                            <tr>
                            <td><b>ID: </b></td>
                              <td>${this.parseValue(result.data.files.id)}</td>
                            </tr>
                            <tr>
                            <td><b>Alias: </b></td>
                              <td>${this.parseValue(result.data.files.alias)}</td>
                            </tr>
                            <tr>
                            <td><b>Förnamn: </b></td>
                              <td>${this.parseValue(result.data.files.given_name)}</td>
                            </tr>
                            <tr>
                            <td><b>Efternamn: </td>
                              <td>${this.parseValue(result.data.files.family_name)}</td>
                            </tr>
                            <tr>
                            <td><b>Kön: </b></td>
                              <td>${this.parseValue(result.data.files.gender)}</td>
                            </tr>
                            <tr>
                            <td><b>Typ: </b></td>
                              <td>${this.parseValue(result.data.files.type)}</td>
                            </tr>
                            <tr>
                            <td><b>Synlig: </b></td>
                              <td>${this.parseValue(result.data.files.hidden)}</td>
                            </tr>
                            <tr>
                            <td><b>skapad: </b></td>
                              <td>${this.parseValue(result.data.files.created_at)}</td>
                            </tr>
                            <tr>
                            <td><b>Uppdaterad: </b></td>
                              <td>${this.parseValue(result.data.files.updated_at)}</td>
                            </tr>
                            <tr>
                            <td><b>Verifierad: </b></td>
                              <td>${this.parseValue(result.data.files.authenticated_at)}</td>
                            </tr>
                            ${result.data.files.files
                                .map(
                                    (f) =>
                                        `
                                        <tr>
                                        <td><b>Alias: </b></td>
                                            <td>${this.parseValue(f.alias)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Synlig: </b></td>
                                            <td>${this.parseValue(f.hidden)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>uuid: </b></td>
                                            <td>${this.parseValue(f.uuid)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Status: </b></td>
                                            <td>${this.parseValue(f.status)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Image: </b></td>
                                            <td>${this.parseValue(f.image)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Typ: </b></td>
                                            <td>${this.parseValue(f.type)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Latitud: </b></td>
                                            <td>${this.parseValue(f.latitude)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Longitud: </b></td>
                                            <td>${this.parseValue(f.longitude)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Skapad: </b></td>
                                            <td>${this.parseValue(f.created_at)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Uppdaterad: </b></td>
                                            <td>${this.parseValue(f.updated_at)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Godkänd: </b></td>
                                            <td>${this.parseValue(f.authenticated_at)} </td>
                                        </tr>
                                        <td>
                                        <img src="https://api.aware.appbolaget.se/@media/${f.uuid}?w=350">
                                        <hr>
                                        </td>

                                        ${f.meta
                                            .map(
                                                (k) =>
                                                    `
                                                    <tr>
                                                    <td><b>ID: </b></td>
                                                    <td>${this.parseValue(k.id)}</td>
                                                    </tr>
                                                    <tr>
                                                    <td><b>Resource ID: </b></td>
                                                    <td>${this.parseValue(k.resource_id)}</td>
                                                    </tr>
                                                    <tr>
                                                    <td><b>Värde: </b></td>
                                                    <td>${this.parseValue(k.value)}</td>
                                                    </tr>
                                                    <tr>
                                                    <td><b>Status: </b></td>
                                                    <td>${this.parseValue(k.status)}</td>
                                                    </tr>
                                                    <tr>
                                                    <td><b>Unik: </b></td>
                                                    <td>${this.parseValue(k.uniqe)}
                                                    <hr></td>
                                                    </tr>
                                                `,
                                            )
                                            .join(' ')}
                                    `,
                                )
                                .join('')}
                            </table>
                            <hr>
                            `,
                        },
                        {
                            kategorier: 'Gemensamma filer',
                            description: ``,
                            info: `
                            <table>
                            ${result.data.pivot_files
                                .map((m) => {
                                    return `
                                      <tr>
                                        <td><b>${m.key}</b></td>
                                        <td>${m.value}</td>
                                      </tr>
                                    `;
                                })
                                .join(' ')}
                            </table>
                        `,
                        },
                        {
                            kategorier: 'Fields',
                            description: ``,
                            info: result.data.fields
                                .map(
                                    (k) =>
                                        `
                                    <table>
                                        <tr>
                                        <td><b>Titel: </b></td>
                                            <td>${this.parseValue(k.title)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Alias: </b></td>
                                            <td>${this.parseValue(k.alias)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Parent: </b></td>
                                            <td>${this.parseValue(k.parent_id)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Enhets ID: </b></td>
                                            <td>${this.parseValue(k.unit_id)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Typ: </b></td>
                                            <td>${this.parseValue(k.type)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Position: </b></td>
                                            <td>${this.parseValue(k.position)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Synlig: </b></td>
                                            <td>${this.parseValue(k.hidden)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Skapad: </b></td>
                                            <td>${this.parseValue(k.created_at)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Uppdaterad: </b></td>
                                            <td>${this.parseValue(k.updated_at)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Borttagen: </b></td>
                                            <td>${this.parseValue(k.deleted_at)}</td>
                                        </tr>
                                        <td><b>Borttagen: </b></td>
                                        <td>${this.parseValue(k.title)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>URL: </b></td>
                                            <td>${this.parseValue(k.url)}</td>
                                        </tr>
                                        <tr>
                                        <td><b>Fråga: </b></td>
                                        <td>${k.fields
                                            .map(
                                                (f) =>
                                                    `
                                                    ${this.parseValue(f.title)}
                                                `,
                                            )
                                            .join(' ')}
                                            <td></td>
                                        </td>
                                        </tr>
                                        <tr>
                                        <td><b>svar: </b></td>
                                        <td>${k.fields.map((f) => this.getFieldsAnswer(f))}</td>
                                        </tr>
                                        `,

                                    `
                                    </table>
                                    <hr>
                                    `,
                                )
                                .join(' '),
                        },
                        {
                            kategorier: 'Meddelanden',
                            description: `Meddelanden du har skickat`,
                            info: result.data.messages
                                .map(
                                    (m) =>
                                        `
                                    <table>
                                        <tr>
                                        <td><b>Alias: </b></td>
                                            <td>${this.parseValue(m.Alias)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Meddelande: </b></td>
                                            <td>${this.parseValue(m.message)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Tråd ID: </b></td>
                                            <td>${this.parseValue(m.thread_id)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>CLient ID: </b></td>
                                            <td>${this.parseValue(m.client_id)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Skapad: </b></td>
                                            <td>${this.parseValue(m.created_at)} </td>
                                        </tr>
                                        <tr>
                                        <td><b>Uppdaterad: </b></td>
                                            <td>${this.parseValue(m.updated_at)} </td>
                                        </tr>
                                    </table>
                                    <hr>
                                `,
                                )
                                .join(' '),
                        },
                        {
                            kategorier: 'Transaktioner',
                            description: ``,
                            info: result.data.transactions
                                .map(
                                    (m) =>
                                        `
                                <table>
                                <tr>
                                <td><b>ID: </b></td>
                                    <td>${this.parseValue(m.id)}</td>
                                </tr>
                                <tr>
                                <td><b>UUID: </b></td>
                                    <td>${this.parseValue(m.uuid)}</td>
                                </tr>
                                <tr>
                                <td><b>Produktnummer: </b></td>
                                    <td>${this.parseValue(m.product_no)}</td>
                                </tr>
                                <tr>
                                <td><b>Order nummer: </b></td>
                                    <td>${this.parseValue(m.order_no)}</td>
                                </tr>
                                <tr>
                                <td><b>Kvantitet: </b></td>
                                    <td>${this.parseValue(m.quantity)}</td>
                                </tr>
                                <tr>
                                <td><b>Vat ID: </b></td>
                                    <td>${this.parseValue(m.vat_id)}</td>
                                </tr>
                                <tr>
                                <td><b>Vat: </b></td>
                                    <td>${this.parseValue(m.vat)}</td>
                                </tr>
                                <tr>
                                <td><b>Valuta: </b></td>
                                    <td>${this.parseValue(m.currency)}</td>
                                </tr>
                                <tr>
                                <td><b>Summa: </b></td>
                                    <td>${this.parseValue(m.amount)}</td>
                                </tr>
                                <tr>
                                <td><b>Återbetalad summa: </b></td>
                                    <td>${this.parseValue(m.refunded_amount)}</td>
                                </tr>
                                <tr>
                                <td><b>Referens: </b></td>
                                    <td>${this.parseValue(m.reference)}</td>
                                </tr>
                                <tr>
                                <td><b>Betalningsreferens: </b></td>
                                    <td>${this.parseValue(m.payment_reference)}</td>
                                </tr>
                                <tr>
                                <td><b>Betalningsmetod: </b></td>
                                    <td>${this.parseValue(m.payment_type)}</td>
                                </tr>
                                <tr>
                                <td><b>Betalningsstatus: </b></td>
                                    <td>${this.parseValue(m.payment_status)}</td>
                                </tr>
                                <tr>
                                <td><b>Verifierad: </b></td>
                                    <td>${this.parseValue(m.verified)}</td>
                                </tr>
                                <tr>
                                <td><b>Inbetalad: </b></td>
                                    <td>${this.parseValue(m.paid_in)}</td>
                                </tr>
                                <tr>
                                <td><b>Återbetalad: </b></td>
                                    <td>${this.parseValue(m.refunded)}</td>
                                </tr>
                                <tr>
                                <td><b>Inbetalad: </b></td>
                                    <td>${this.parseValue(m.paid_in)}</td>
                                </tr>
                                <tr>
                                <td><b>Godkännd: </b></td>
                                    <td>${this.parseValue(m.ccompleted)}</td>
                                </tr>
                                <tr>
                                <td><b>Utbetalad: </b></td>
                                    <td>${this.parseValue(m.paid_out)}</td>
                                </tr>
                                <tr>
                                <td><b>Paketerad: </b></td>
                                    <td>${this.parseValue(m.packaged)}</td>
                                </tr>
                                <tr>
                                <td><b>Skickad: </b></td>
                                    <td>${this.parseValue(m.sent)}</td>
                                </tr>
                                <tr>
                                <td><b>Levererad: </b></td>
                                    <td>${this.parseValue(m.delivered)}</td>
                                </tr>
                                <tr>
                                <td><b>Borttagen: </b></td>
                                    <td>${this.parseValue(m.deleted)}</td>
                                </tr>
                                <tr>
                                <td><b>Avbruten: </b></td>
                                    <td>${this.parseValue(m.cancelled)}</td>
                                </tr>
                                <tr>
                                <td><b>Raderad: </b></td>
                                    <td>${this.parseValue(m.deleted)}</td>
                                </tr>
                                <tr>
                                <td><b>Typ: </b></td>
                                    <td>${this.parseValue(m.type)}</td>
                                </tr>
                                <tr>
                                <td><b>Skapad: </b></td>
                                    <td>${this.parseValue(m.deleted_at)}</td>
                                </tr>
                                <tr>
                                <td><b>Uppdaterad: </b></td>
                                    <td>${this.parseValue(m.updated_at)}</td>
                                </tr>
                                <tr>
                                <td><b>Borttagen: </b></td>
                                    <td>${this.parseValue(m.deleted_at)}</td>
                                </tr>
                                </table>
                                <hr>
                                `,
                                )
                                .join(' '),
                        },
                    ];
                }),
            )
            .subscribe();
    }

    private parseValue(value) {
        if (!value || value === undefined) {
            return '-';
        }

        return value;
    }

    private getUnitNameByRole(r, units) {
        const unit = units.find((u) => u.id === r.unit_id);

        return unit ? unit.title : '-';
    }

    private getFieldsAnswer(field) {
        let answers = field.answers.map(({ value }) => {
            const temp = [];

            for (const key in field.options) {
                if (key === value) {
                    temp.push(' ' + field.options[key]);
                }
            }

            return temp;
        });

        answers = answers.flat();
        return answers;
    }

    private parseClient(client) {
        for (const key in client) {
            if (client[key]) {
                if (typeof client[key] === 'string') {
                    this.data.client.push({
                        key,
                        value: client[key],
                    });
                }
            }
        }

        if (client.meta) {
            for (const meta of client.meta) {
                for (const key in meta) {
                    if (meta[key]) {
                        this.data.client.push({
                            key,
                            value: meta[key],
                        });
                    }
                }
            }
        }
    }
}

export interface GDPRtable {
    kategorier: string;
    info: any;
    description: string;
}
